// import React, { useState, useEffect, useRef } from 'react';
// import Slider from 'react-slick';
// import RightArrow from '../../SVG/RightArrow';
// import HomeServiceCard from '../Cards/HomeServiceCard'; // Ensure this path is correct
// import { useNavigate } from 'react-router-dom';

// // Import slick css in your main App.js or here
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";

// const OurServices = () => {
//     let navigate = useNavigate();
//     const [isVisible, setIsVisible] = useState(false);
//     const sectionRef = useRef(null);

//     useEffect(() => {
//         const observer = new IntersectionObserver(
//             ([entry]) => { if (entry.isIntersecting) setIsVisible(true); },
//             { threshold: 0.15 }
//         );
//         if (sectionRef.current) observer.observe(sectionRef.current);
//         return () => observer.disconnect();
//     }, []);

//     let service = [
//         { 
//             title: "Staffing & Recruitment Services", 
//             content: "Build agile, scalable, and business-ready teams through customized staffing services designed for modern workforce requirements. We help businesses streamline hiring operations and reduce delays.", 
//             included: ["Contract Staffing", "Permanent Staffing", "IT Staffing", "Non-IT Staffing"],
//             cta: "Explore Staffing",
//             slug: '/service/staffing' 
//         },
//         { 
//             title: "Specialized Recruitment", 
//             content: "Hire highly skilled professionals through strategic specialized recruitment services designed for leadership hiring, startup expansion, and modern workforce requirements.", 
//             included: ["Executive Search", "GCC Hiring", "Startup Hiring", "Remote Hiring"],
//             cta: "Explore Specialized",
//             slug: '/service/specialized' 
//         },
//         { 
//             title: "Recruitment Process Outsourcing", 
//             content: "Transform fragmented hiring operations into scalable and efficient recruitment systems through advanced RPO services designed for growing businesses.", 
//             included: ["RPO Services", "Project RPO Services"],
//             cta: "Explore RPO",
//             slug: '/service/rpo' 
//         },
//         { 
//             title: "HR Outsourcing Services", 
//             content: "Simplify workforce management with professional HR outsourcing services designed to improve operational efficiency, employee administration, and compliance management.", 
//             included: ["Process Outsourcing", "HR Administration", "HR Documentation", "HR Compliance"],
//             cta: "Explore HR Outsourcing",
//             slug: '/service/hr-outsourcing' 
//         },
//         { 
//             title: "Payroll & Compliance Services", 
//             content: "Manage payroll operations accurately and efficiently through secure and scalable payroll outsourcing services tailored for modern businesses.", 
//             included: ["Payroll Services", "Payroll Processing", "Outsourcing", "Contractor Payroll"],
//             cta: "Explore Payroll",
//             slug: '/service/payroll' 
//         },
//         { 
//             title: "Statutory & Compliance", 
//             content: "Reduce legal and compliance risks through reliable statutory compliance services designed to support smooth workforce operations and regulatory adherence.", 
//             included: ["Statutory Compliance", "PF & ESI Management"],
//             cta: "Explore Compliance",
//             slug: '/service/compliance' 
//         },
//     ];

//     let settings = {
//         dots: false,
//         arrows: false,
//         speed: 1000,
//         slidesToShow: 3,
//         autoplay: true,
//         autoplaySpeed: 3000,
//         infinite: true,
//         responsive: [
//             { breakpoint: 1040, settings: { slidesToShow: 2 } },
//             { breakpoint: 640, settings: { slidesToShow: 1 } }
//         ]
//     };

//     return (
//         <div ref={sectionRef} className="servicebg py-10 overflow-hidden">
//             <main className='container mx-auto px-6 lg:flex items-center gap-10' >
//                 <section className={`lg:w-1/3 mb-10 lg:mb-0 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10'}`}>
//                     <p className='text-xs uppercase tracking-widest font-semibold text-blue-400 mb-2' >
//                         End-To-End HR Consulting Services
//                     </p>
//                     <h2 className='text-2xl md:text-4xl font-bold text-white mb-6 syne' >
//                         Built Around Business Performance
//                     </h2>
//                     <p className='text-white/80 text-sm mb-6 leading-relaxed'>
//                         Unlike traditional agencies offering fragmented support, we operate as a complete HR consulting services company delivering integrated workforce solutions under one strategic framework.
//                     </p>
//                     <button onClick={() => navigate('/service/RPO')} className='flex gap-2 items-center text-white bg-blue-600 hover:bg-blue-700 px-6 py-3 rounded-full transition-all'>
//                         See All <RightArrow size={18} />
//                     </button>
//                 </section>

//                 <section className={`lg:w-2/3 transition-all duration-1000 delay-300 ${isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-95'}`}>
//                     <Slider {...settings}>
//                         <HomeServiceCard data={service[0]} />
//                         <HomeServiceCard data={service[1]} bg='bg-white' />
//                         <HomeServiceCard data={service[2]} bg='bg-slate-600' />
//                         <HomeServiceCard data={service[3]} />
//                         <HomeServiceCard data={service[4]} bg='bg-white' />
//                         <HomeServiceCard data={service[5]} bg='bg-slate-600' />
//                     </Slider>
//                 </section>
//             </main>
//         </div>
//     );
// };

// export default OurServices;


// import React from 'react';
// import { motion } from 'framer-motion';
// import RightArrow from '../../SVG/RightArrow';
// import HomeServiceCard from '../Cards/HomeServiceCard';
// import { useNavigate } from 'react-router-dom';

// const OurServices = () => {
//     let navigate = useNavigate();

//     let service = [
//         { title: "Staffing & Recruitment", content: "Build business-ready teams through customized staffing services designed for modern requirements.", included: ["Contract", "Permanent", "IT Staffing", "Non-IT"], slug: '/service/staffing' },
//         { title: "Specialized Recruitment", content: "Hire highly skilled professionals through strategic search for leadership and startup expansion.", included: ["Executive", "GCC", "Startups", "Remote"], slug: '/service/specialized' },
//         { title: "Recruitment Outsourcing", content: "Transform hiring operations into scalable and efficient systems through advanced RPO services.", included: ["RPO Services", "Project RPO"], slug: '/service/rpo' },
//         { title: "HR Outsourcing Services", content: "Simplify workforce management with professional services designed to improve employee administration.", included: ["Process", "Administration", "Compliance"], slug: '/service/hr-outsourcing' },
//         { title: "Payroll & Compliance", content: "Manage payroll operations accurately and efficiently through secure and scalable outsourcing.", included: ["Payroll", "Processing", "Contractor"], slug: '/service/payroll' },
//         { title: "Statutory & Compliance", content: "Reduce legal risks through reliable services designed to support smooth workforce operations.", included: ["Statutory", "PF & ESI Management"], slug: '/service/compliance' },
//     ];

//     return (
//         <section className="bg-white py-24 relative overflow-hidden">
//             {/* --- DECORATIVE BACKGROUND ELEMENTS (Prevents 'Empty' feel) --- */}
//             <div className="absolute top-0 left-0 w-full h-full pointer-events-none">
//                 <div className="absolute top-20 left-10 w-96 h-96 bg-blue-50/50 blur-[100px] rounded-full" />
//                 <div className="absolute bottom-20 right-10 w-96 h-96 bg-blue-50/50 blur-[100px] rounded-full" />
//                 {/* Subtle Grid Lines */}
//                 <div className="absolute inset-0 opacity-[0.03]" style={{ backgroundImage: 'radial-gradient(#000 1px, transparent 1px)', backgroundSize: '40px 40px' }} />
//             </div>

//             <div className="container mx-auto px-6 relative z-10">

//                 {/* --- CENTERED TOP HEADER --- */}
//                 <div className="max-w-4xl mx-auto text-center mb-20">
//                     <motion.span 
//                         initial={{ opacity: 0 }}
//                         whileInView={{ opacity: 1 }}
//                         className="text-blue-600 font-black tracking-[0.4em] text-[10px] uppercase block mb-4"
//                     >
//                         /// Strategic HR Ecosystem
//                     </motion.span>
//                     <motion.h2 
//                         initial={{ opacity: 0, y: 20 }}
//                         whileInView={{ opacity: 1, y: 0 }}
//                         className="text-4xl md:text-6xl font-extrabold text-slate-900 syne leading-tight mb-8"
//                     >
//                         Built Around Business <span className="text-blue-600 italic">Performance.</span>
//                     </motion.h2>
//                     <motion.p 
//                         initial={{ opacity: 0 }}
//                         whileInView={{ opacity: 1 }}
//                         className="text-slate-500 text-lg md:text-xl max-w-2xl mx-auto leading-relaxed"
//                     >
//                         Unlike traditional agencies offering fragmented support, we operate as a complete HR consulting partner delivering integrated solutions.
//                     </motion.p>
//                 </div>

//                 {/* --- MASONRY / BENTO GRID --- */}
//                 <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
//                     {service.map((item, index) => (
//                         <div key={index} className={`${index % 3 === 1 ? 'lg:translate-y-12' : ''}`}>
//                             <HomeServiceCard 
//                                 data={item} 
//                                 index={index}
//                                 // Strategic Color Mixing
//                                 isBlue={index === 0 || index === 3 || index === 5} 
//                             />
//                         </div>
//                     ))}
//                 </div>

//                 {/* --- BOTTOM CTA (Balances the vertical flow) --- */}
//                 <motion.div 
//                     initial={{ opacity: 0, y: 20 }}
//                     whileInView={{ opacity: 1, y: 0 }}
//                     className="mt-32 flex flex-col items-center border-t border-slate-100 pt-16"
//                 >
//                     <p className="text-slate-400 font-bold uppercase text-xs tracking-widest mb-8">
//                         Ready to optimize your workforce?
//                     </p>
//                     <button 
//                         onClick={() => navigate('/service/staffing')}
//                         className="group bg-slate-900 text-white px-12 py-5 rounded-2xl font-bold flex items-center gap-4 transition-all hover:bg-blue-600 shadow-2xl hover:shadow-blue-200"
//                     >
//                         EXPLORE ALL SOLUTIONS
//                         <RightArrow size={20} className="group-hover:translate-x-1 transition-transform" />
//                     </button>
//                 </motion.div>

//             </div>
//         </section>
//     );
// };

// export default OurServices;


import React from 'react';
import { motion } from 'framer-motion';
import RightArrow from '../../SVG/RightArrow';
import HomeServiceCard from '../Cards/HomeServiceCard';
import { useNavigate } from 'react-router-dom';
import staffingImg from '../../Assest/cards/home/1/Staffing & Recruitment.avif';
import specializedImg from '../../Assest/cards/home/1/Specialized Recruitment.avif';
import rpoImg from '../../Assest/cards/home/1/Recruitment Outsourcing.avif';
import hrOutsourcingImg from '../../Assest/cards/home/1/HR Outsourcing Services.avif';
import payrollImg from '../../Assest/cards/home/1/Payroll & Compliance.avif';
import statutoryImg from '../../Assest/cards/home/1/Statutory & Compliance.avif';

const OurServices = () => {
    let navigate = useNavigate();

    let service = [
        { title: "Staffing & Recruitment", image: staffingImg, cta: "Explore Staffing Solutions", content: "Build business-ready teams through customized staffing services designed for modern requirements.", included: ["Contract", "Permanent", "IT Staffing", "Non-IT"], slug: '/service/staffing' },
        { title: "Specialized Recruitment", image: specializedImg, cta: "Explore Specialized Recruitment Services", content: "Hire highly skilled professionals through strategic search for leadership and startup expansion.", included: ["Executive", "GCC", "Startups", "Remote"], slug: '/service/specialized-recruitment' },
        { title: "Recruitment Outsourcing", image: rpoImg, cta: "Explore RPO Services", content: "Transform hiring operations into scalable and efficient systems through advanced RPO services.", included: ["RPO Services", "Project RPO"], slug: '/service/rpo' },
        { title: "HR Outsourcing Services", image: hrOutsourcingImg, cta: "Explore HR Outsourcing Services", content: "Simplify workforce management with professional services designed to improve employee administration.", included: ["Process", "Administration", "Compliance"], slug: '/service/hr-outsourcing' },
        { title: "Payroll & Compliance", image: payrollImg, cta: "Explore Payroll & Compliance Solutions", content: "Manage payroll operations accurately and efficiently through secure and scalable outsourcing.", included: ["Payroll", "Processing", "Contractor"], slug: '/service/payroll' },
        { title: "Statutory & Compliance", image: statutoryImg, cta: "Explore Statutory & Compliance Services", content: "Reduce legal risks through reliable services designed to support smooth workforce operations.", included: ["Statutory", "PF & ESI Management"], slug: '/service/compliance' },
    ];

    return (
        <section className="bg-white py-32 relative overflow-hidden">

            {/* --- ARCHITECTURAL BACKGROUND (Fills the 'Empty' space) --- */}
            <div className="absolute inset-0 pointer-events-none">
                {/* Subtle Blueprint Grid */}
                <div className="absolute inset-0 opacity-[0.05]" style={{ backgroundImage: 'linear-gradient(#2563eb 1px, transparent 1px), linear-gradient(90deg, #2563eb 1px, transparent 1px)', backgroundSize: '60px 60px' }} />
                {/* Soft Blue Glows */}
                <div className="absolute top-0 right-0 w-[800px] h-[800px] bg-blue-50 blur-[120px] rounded-full" />
                <div className="absolute bottom-0 left-0 w-[600px] h-[600px] bg-blue-50/50 blur-[100px] rounded-full" />
            </div>

            <div className="container mx-auto px-6 relative z-10">

                {/* --- CENTERED HERO HEADER --- */}
                <div className="max-w-4xl mx-auto text-center mb-24">
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                    >
                        {/* <span className="text-blue-600 font-black tracking-[0.4em] text-[10px] uppercase block mb-4">
                            /// Our Service Ecosystem
                        </span> */}
                        <h2 className="text-3xl md:text-5xl font-bold text-slate-900 syne leading-tight mb-8">
                            Built Around <br /> Business <span className="text-blue-600 ">Performance.</span>
                        </h2>
                        <p className="text-slate-500 text-base md:text-lg max-w-2xl mx-auto leading-relaxed font-medium">
                            Unlike traditional agencies, we operate as a complete HR consulting partner delivering <span className="text-blue-600">integrated workforce solutions.</span>
                        </p>
                    </motion.div>
                </div>

                {/* --- BENTO STAGGERED GRID --- */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
                    {service.map((item, index) => (
                        <div key={index} className="h-full flex flex-col">
                            <HomeServiceCard
                                data={item}
                                index={index}
                                // Strategic Blue Card Placement for visual balance
                                isBlue={index === 0 || index === 3 || index === 5}
                            />
                        </div>
                    ))}
                </div>

                {/* --- FOOTER CTA SECTION --- */}
                {/* <motion.div 
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    className="mt-32 p-12 rounded-[3rem] bg-blue-50 border border-blue-100 flex flex-col items-center text-center"
                >
                    <h3 className="text-2xl font-bold text-slate-900 mb-4 syne">Need a customized workforce plan?</h3>
                    <p className="text-slate-600 mb-10 max-w-lg">
                        Talk to our consulting experts and discover how we can streamline your HR operations.
                    </p>
                    <button 
                        onClick={() => navigate('/service/staffing')}
                        className="group bg-blue-600 text-white px-5 py-3 rounded-2xl font-bold flex items-center gap-4 transition-all hover:bg-slate-900 shadow-xl shadow-blue-200 hover:shadow-slate-200"
                    >
                        DISCUSS YOUR HR NEEDS
                        <RightArrow size={20} className="group-hover:translate-x-1 transition-transform" />
                    </button>
                </motion.div> */}

            </div>
        </section>
    );
};

export default OurServices;